import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import authApi from '../../api/auth';
import { LOGIN_COVER } from '../../assets/images';
import TextInput from '../../components/TextInput';
import { useAppDispatch, useAppSelector } from '../../hooks/useRedux';
import { useEffect, useState } from 'react';
import { login } from '../../reducers/authSlice';
import { HIDE, SHOW } from '../../assets/icons';
import { Button } from '@wot/components';
import { toast } from 'react-toastify';

export default function Login() {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();
  const { admin } = useAppSelector((state) => state.authSlice);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [error, setError] = useState('');
  const [values, setValues] = useState({
    password: '',
    showPassword: false
  });
  const [loading, setLoading] = useState(false);

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const onSubmit = (data: any) => {
    setLoading(true);
    authApi
      .login(data.email, data.password)
      .then((res) => {
        setLoading(false);
        if (res.data && res.data._id) {
          dispatch(login({ ...res.data, id: res.data._id }));
        } else {
          setLoading(false);
          setError(res.message || '');
        }
      })
      .catch(() => {
        toast.error('Something went wrong.');
        setLoading(false);
      });
  };

  useEffect(() => {
    if (admin.id) {
      navigate('/');
    }
  }, [admin]);

  return (
    <div className="w-full flex flex-row h-screen">
      <div className="bg-primary w-1/2 h-full">
        <div className="w-full h-full flex flex-col items-center justify-center">
          <div className="h-80">
            <img src={LOGIN_COVER} alt="WorldOTutor login cover" className="w-full h-full object-contain" />
          </div>
          <div className="w-1/2">
            <h1 className="text-5xl leading-snug font-bold text-white text-center">Welcome to World O Tutor</h1>
          </div>
        </div>
      </div>

      <div className="flex w-1/2 h-full items-center justify-center">
        <form
          // onSubmit={handleSubmit(onSubmit)}
          onSubmit={(e) => e.preventDefault()}
          className="flex flex-col w-4/5 h-4/5 mx-auto px-10 py-10 rounded-xl border-2 border-primary"
        >
          <div className="flex justify-center">
            <h5 className="text-2xl text-black font-semibold">Log In</h5>
          </div>
          <div className="flex flex-col mt-10">
            <TextInput
              errors={errors}
              label={'Enter Email ID'}
              name={'email'}
              placeholder={'example.com'}
              register={register}
              type="email"
              required={'Please enter the Email Id'}
            />
          </div>
          <div className="flex flex-col mt-10 relative">
            <TextInput
              errors={errors}
              label={'Enter Password'}
              name={'password'}
              placeholder={''}
              register={register}
              type={values.showPassword ? 'text' : 'password'}
              required={'Please enter the password'}
            />
            <p className="absolute right-3 top-9 cursor-pointer items-center" onClick={handleClickShowPassword}>
{values.showPassword ? (
                <img src={SHOW} alt="Hide password" className="w-6 h-6" />
              ) : (
                <img src={HIDE} alt="Show password" className="w-6 h-6" />
              )}
            </p>
          </div>
          {error && <p className="text-red-500 text-sm">{error}</p>}
          <div className="w-full my-10">
            <Button text="Proceed" loading={loading} block onClick={handleSubmit(onSubmit)} role="submit" />
          </div>
        </form>
      </div>
    </div>
  );
}
